import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { MoonLoader } from "react-spinners";

import { useSession } from "@/hooks/server-state/use-session";

import ForgotPassword from "@/components/widget/forgot-password";
import Login from "@/components/widget/login";

import {
  AuthLayout,
  ForgotPasswordLink,
  ResumeLink
} from "@/components/layout/auth-layout";

const RESUME_ADDRESS = import.meta.env.VITE_WEBSITE_ADDRESS;

const LoginPage = () => {
  const navigate = useNavigate();
  const { data: session, isLoading } = useSession();
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  useEffect(() => {
    if (session) {
      navigate("/dashboard/");
    }
  }, [session, navigate]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (session) {
    return null;
  }

  const footerContent = (
    <>
      {RESUME_ADDRESS && <ResumeLink />}
      {!showForgotPassword && (
        <ForgotPasswordLink
          onClick={() => setShowForgotPassword(!showForgotPassword)}
        />
      )}
    </>
  );

  return (
    <AuthLayout footerContent={footerContent}>
      {showForgotPassword ? (
        <ForgotPassword onBack={() => setShowForgotPassword(false)} />
      ) : (
        <Login />
      )}
    </AuthLayout>
  );
};

const LoadingScreen = () => (
  <div className="flex h-screen w-full items-center justify-center">
    <MoonLoader color="#0099A5" size={50} />
  </div>
);

export default LoginPage;
